import { css, CSSResult } from 'lit'
import { csSpacing } from '@cloudsuite/mosaic-shared/styles/spacing.style.js'


export const style: CSSResult = css`
  .view-store-button {
    margin-top: ${csSpacing.spacing05};
  }

   cse-group {
    --cse-group-alignment: flex-start;
   }

`
